// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reaction-select[data-v-5bfe8d2c] {
  width: 250px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  opacity: 0.9;
  overflow: hidden;
}
.reaction-select .handup-wrapper[data-v-5bfe8d2c],
.reaction-select .reactions-wrapper[data-v-5bfe8d2c] {
  margin: 10px;
  border-radius: 10px;
  background: var(--vm-handup-wrapper-bg);
  color: white;
}
.reaction-select .handup-wrapper[data-v-5bfe8d2c]:not(:first-child),
.reaction-select .reactions-wrapper[data-v-5bfe8d2c]:not(:first-child) {
  margin-top: 0;
}
.reaction-select .handup-wrapper[data-v-5bfe8d2c] {
  display: flex;
  flex-direction: row;
  padding: 10px;
  cursor: pointer;
}
.reaction-select .handup-wrapper[data-v-5bfe8d2c]:hover {
  background-color: var(--bg-color-hover);
}
.reaction-select .handup-wrapper > *[data-v-5bfe8d2c]:first-child {
  margin-left: auto;
  margin-right: 5px;
}
.reaction-select .handup-wrapper > *[data-v-5bfe8d2c]:last-child {
  margin-right: auto;
}
.reaction-select .reactions-wrapper[data-v-5bfe8d2c] {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c] {
  display: flex;
  padding: 10px;
  cursor: pointer;
}
.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c]:hover {
  background-color: var(--bg-color-hover);
  border-radius: 10px;
}
.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c] img {
  margin: auto !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfReactions.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,aAAa;EACb,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".reaction-select[data-v-5bfe8d2c] {\n  width: 250px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n  opacity: 0.9;\n  overflow: hidden;\n}\n.reaction-select .handup-wrapper[data-v-5bfe8d2c],\n.reaction-select .reactions-wrapper[data-v-5bfe8d2c] {\n  margin: 10px;\n  border-radius: 10px;\n  background: var(--vm-handup-wrapper-bg);\n  color: white;\n}\n.reaction-select .handup-wrapper[data-v-5bfe8d2c]:not(:first-child),\n.reaction-select .reactions-wrapper[data-v-5bfe8d2c]:not(:first-child) {\n  margin-top: 0;\n}\n.reaction-select .handup-wrapper[data-v-5bfe8d2c] {\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  cursor: pointer;\n}\n.reaction-select .handup-wrapper[data-v-5bfe8d2c]:hover {\n  background-color: var(--bg-color-hover);\n}\n.reaction-select .handup-wrapper > *[data-v-5bfe8d2c]:first-child {\n  margin-left: auto;\n  margin-right: 5px;\n}\n.reaction-select .handup-wrapper > *[data-v-5bfe8d2c]:last-child {\n  margin-right: auto;\n}\n.reaction-select .reactions-wrapper[data-v-5bfe8d2c] {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c] {\n  display: flex;\n  padding: 10px;\n  cursor: pointer;\n}\n.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c]:hover {\n  background-color: var(--bg-color-hover);\n  border-radius: 10px;\n}\n.reaction-select .reactions-wrapper .reaction[data-v-5bfe8d2c] img {\n  margin: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
